module.exports = __webpack_public_path__ + "img/whats-new-2_en.60908c4.jpg";